import React from 'react';
import { View, Text } from 'react-native';
import { IconFill, IconFillProps, IconOutline } from '@ant-design/icons-react-native';
import { useSendbirdChat } from '@sendbird/uikit-react-native';
import { useTotalUnreadMessageCount } from '@sendbird/uikit-chat-hooks';

const IconComponent = ({ focused, size, color }: { focused: boolean; size: number; color: string }) => {
    if (focused) {
        return <IconFill name={'message' as IconFillProps['name']} size={size} color={color} />;
    }
    return <IconOutline name={'message' as any} size={size} color={color} />;
};

export const ChatTabIcon = ({ color, size, focused }: { color: string; size: number; focused: boolean }): React.ReactElement => {
    const { sdk } = useSendbirdChat();
    const unreadCount = useTotalUnreadMessageCount(sdk, { maxCount: 99 });

    return (
        <View>
            <IconComponent focused={focused} size={size} color={color} />
            {unreadCount !== '0' && (
                <View className="absolute -top-2 -right-2.5 min-w-5 h-5 rounded-lg bg-red-500 items-center justify-center px-1">
                    <Text className="text-white text-xs font-bold leading-none">
                        {unreadCount}
                    </Text>
                </View>
            )}
        </View>
    );
};
